import React from 'react'
import { ChevronLeftIcon } from '@/atoms/Icons/ChevronLeftIcon'
import { InternalLink } from '@/atoms/InternalLink'
import { AsSpan, ParagraphSM } from '@/atoms/Text'
import { paths, slugs } from '@/constants'
import { useTranslate } from '@/utils/translate/translate-client'

interface LivestreamBreadcrumbProps {
  projectSlug: string
  projectName: string
  livestreamTitle: string
}

export const LivestreamBreadcrumb: React.FC<LivestreamBreadcrumbProps> = ({
  projectSlug,
  projectName,
  livestreamTitle,
}) => {
  const { t } = useTranslate('livestream')

  return (
    <div className="line-clamp-1">
      <ChevronLeftIcon className="mr-2 inline" color="oxide" />
      <ParagraphSM className="text-oxide" as={AsSpan}>
        <InternalLink href={paths.watch.index}>{t('watch', 'Watch')}</InternalLink>
      </ParagraphSM>
      {projectSlug !== slugs.forYourConsideration && (
        <>
          <ParagraphSM className="mx-2 text-gray-600" as={AsSpan}>
            /
          </ParagraphSM>
          <ParagraphSM className="text-oxide" as={AsSpan}>
            <InternalLink href={`${paths.watch.index}/${projectSlug}`}>{projectName}</InternalLink>
          </ParagraphSM>
        </>
      )}
      <ParagraphSM className="mx-2 text-gray-600 " as={AsSpan}>
        /
      </ParagraphSM>
      <ParagraphSM className="text-white" as={AsSpan}>
        {livestreamTitle}
      </ParagraphSM>
    </div>
  )
}
